import { PERMISSIONS, ROUTE_PATHS } from "../../../PermissionsConstants";
import { CarrierEAndOReports } from "./CarrierEAndOReports";
import { CarrierEAndOPerStateReports } from "./E&OContactPerState/CarrierEAndOPerStateReports";

export const CarrierSideBar = [
  {
    title: "E&O Contact Report",
    to: ROUTE_PATHS.CarrierEAndO_Reports_Index,
    component: CarrierEAndOReports,
    permission: PERMISSIONS.permission_report_carrier_eandocontact_view,
  },

  {
    title: "E&O Contact Per State Report",
    to: ROUTE_PATHS.CarrierEAndOPerState_Reports_Index,
    component: CarrierEAndOPerStateReports,
    permission: PERMISSIONS.permission_report_carrier_eandocontactperstate_view,
  },
];
